import React from 'react';
import css from './styles.module.scss';
import { Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { FieldError } from 'react-hook-form';
import { TextFieldProps } from '@material-ui/core/TextField/TextField';
import classNames from 'classnames';

interface TextInputProps {
    label: string;
    name: string;
    register: any;
    fieldError?: FieldError;
    placeholder?: any;
    type?: any;
}

type OwnProps = TextInputProps & TextFieldProps;

export const TextInput: React.FC<OwnProps> = ({ name, label, register, fieldError, autoFocus, placeholder, type, className, ...textFieldProps }) => {
    return (
        <div className={css.module}>
            <Typography className={css.fieldName}>{label}</Typography>
            <TextField
                {...textFieldProps}
                className={classNames(className, css.input)}
                variant={`filled`}
                name={name}
                inputRef={register}
                error={!!fieldError}
                helperText={fieldError?.message}
                type={type ? type : 'text'}
                placeholder={placeholder || ''}
            />
        </div>
    );
};

export const TextInput1: React.FC<OwnProps> = ({ name, label, register, fieldError, autoFocus, placeholder, type, className, ...textFieldProps }) => {
    return (
        <div className={css.module}>
            <Typography className={css.fieldName}>{label}</Typography>
            <TextField
                {...textFieldProps}
                className={classNames(className, css.input1)}
                variant={`standard`}
                name={name}
                inputRef={register}
                error={!!fieldError}
                // placeholder={placeholder}
                helperText={fieldError?.message}
            />
        </div>
    );
};

interface NumberInputProps {
    label: string;
    name: string;
    register: any;
    fieldError?: FieldError;
    // placeholder?: any;
    type?: any;
    min: number;
    max: number;
    step: number;
}

type OwnProps1 = NumberInputProps & TextFieldProps;

export const NumberInput: React.FC<OwnProps1> = ({
    name,
    label,
    register,
    fieldError,
    min,
    max,
    step,
    autoFocus,
    // placeholder,
    type,
    className,
    ...textFieldProps
}) => {
    return (
        <div className={css.module}>
            <Typography className={css.fieldName}>{label}</Typography>
            <TextField
                {...textFieldProps}
                className={classNames(className, css.input)}
                variant={`filled`}
                name={name}
                inputRef={register}
                error={!!fieldError}
                // placeholder={placeholder}
                helperText={fieldError?.message}
                type={'number'}
                InputProps={{
                    inputProps: { min: min, max: max, step: step },
                }}
            />
        </div>
    );
};

export const TextInputNew: React.FC<OwnProps> = ({ name, label, register, fieldError, autoFocus, type, className, ...textFieldProps }) => {
    return (
        <div className={css.module} style={{ marginTop: '0' }}>
            <Typography className={css.fieldName}>{label}</Typography>
            <TextField
                {...textFieldProps}
                className={classNames(className, css.inputNew)}
                variant={`filled`}
                name={name}
                inputRef={register}
                error={!!fieldError}
                // placeholder={placeholder}
                helperText={fieldError?.message}
                type={type ? type : 'text'}
                // style={{height:'13px',background:'red'}}
            />
        </div>
    );
};
